import dayjs from "dayjs";

export function createEncodedFilter(jsonFilterArray, orderBy, pageSize, pageNumber) {
	const jsonObject = {};
	jsonObject.items = jsonFilterArray;
	jsonObject.orderBy = orderBy;
	jsonObject.pageSize = pageSize;
	jsonObject.pageNumber = pageNumber;
	let filterParameterString = JSON.stringify(jsonObject);
	let filterParameterEncoded = encodeURIComponent(filterParameterString);
	return filterParameterEncoded;
}

export function createEncodedParameters(parameters) {
	let parametersString = JSON.stringify(parameters);
	let parametersEncoded = encodeURIComponent(parametersString);
	return parametersEncoded;
}

export function generateRandom() {
	const randomId = Math.random().toString(36).substring(2, 9);
	return randomId;
}

export function formatDate(value) {
	if (value) {
		return dayjs(value).format("DD/MM/YYYY");
	} else {
		return null;
	}
}

export function checkOpen(open) {
	if (open) {
		if (typeof open === "object") {
			return Object.keys(open).length !== 0;
		} else {
			return true;
		}
	} else {
		return false;
	}
}

export function getTodayDate() {
	//ritorna la data di oggi a mezzanotte ora locale
	const today = new Date();
	return new Date(today.getFullYear(), today.getMonth(), today.getDate());
}

export function formatDateTime(value) {
	if (value) {
		return dayjs(value).format("DD/MM/YYYY HH:mm");
	} else {
		return null;
	}
}

export function removeObjectWithId(arr, id) {
	const objWithIdIndex = arr.findIndex((obj) => obj.id === id);

	if (objWithIdIndex > -1) {
		arr.splice(objWithIdIndex, 1);
	}

	return arr;
}

export function formatLabel(string, values) {
	let newString;
	// Sostituisco le variabili
	newString = string.replace(/\$\(([A-Za-z0-9_]+)\)/g, function (match, index) {
		return typeof values[index] == "undefined" ? match : values[index] || values[index] === 0 ? values[index] : "";
	});
	// Sostituisco le variabili Date
	newString = newString.replace(/\$d\(([A-z]+)\)/g, function (match, index) {
		return typeof values[index] == "undefined" ? match : values[index] || values[index] === 0 ? dayjs(values[index]).format("DD/MM/YYYY") : "";
	});
	// Sostituisco le variabili Date con Ora
	newString = newString.replace(/\$t\(([A-z]+)\)/g, function (match, index) {
		return typeof values[index] == "undefined" ? match : values[index] || values[index] === 0 ? dayjs(values[index]).format("DD/MM/YYYY HH:mm") : "";
	});
	return newString;
}

export function formatCurrency(value) {
	const formatter = new Intl.NumberFormat("it-IT", {
		style: "currency",
		currency: "EUR",

		// These options are needed to round to whole numbers if that's what you want.
		//minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
		//maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
	});

	return formatter.format(value);
}

export function cellBackgroundColor(backgroundColor) {
	return {
		backgroundColor: backgroundColor,
		width: "100%", // Imposta la larghezza della cella al 100%
		height: "100%", // Imposta l'altezza della cella al 100%
		display: "flex", // Usa il layout flessibile per occupare tutto lo spazio disponibile
		alignItems: "center", // Allinea verticalmente il contenuto al centro
		paddingLeft: "3px",
	};
}

export function isNumeric(value) {
	if (value === null) return false;
	if (typeof value === "number") return true;
	if (typeof value === "string" && value.trim() === "") return false;
	return +value === +value;
}

export function getFirstDayOfMonth() {
	//ritorna il primo giorno del mese ora locale
	const today = new Date();
	return new Date(today.getFullYear(), today.getMonth(), 1);
}

export function getLastDayOfMonth() {
	//ritorna l'ultimo giorno del mese ora locale
	const today = new Date();
	return new Date(today.getFullYear(), today.getMonth() + 1, 0);
}

export function isComponentVisible(objMod, hiddenProp) {
	if (objMod) {
		// Se c'è l'ObjMod comanda lei
		if (objMod.flVisible === "Y") {
			return true;
		} else {
			return false;
		}
	} else {
		if (hiddenProp === true) {
			return false;
		} else {
			return true;
		}
	}
}

export function isComponentDisabled(objMod, disabledProp) {
	if (objMod) {
		// Se c'è l'ObjMod comanda lei
		if (objMod.flDisabled === "Y") {
			return true;
		} else {
			return false;
		}
	} else {
		if (disabledProp === true) {
			return true;
		} else {
			return false;
		}
	}
}

export function isNumericDecimal(value) {
	return /^[0-9]+(,[0-9]+)?$/.test(value);
}

export function isNotEmpty(value) {
	return value !== undefined && value !== null && value !== "";
}
